// @deprecated use ButtonType instead
var ButtonTypes;
(function (ButtonTypes) {
    ButtonTypes["LARGE_POSITIVE"] = "large-positive";
    ButtonTypes["LARGE_NEGATIVE"] = "large-negative";
    ButtonTypes["STANDARD_POSITIVE"] = "positive";
    ButtonTypes["STANDARD_NEGATIVE"] = "negative";
    ButtonTypes["SMALL_POSITIVE"] = "small-positive";
    ButtonTypes["SMALL_NEGATIVE"] = "small-negative";
    ButtonTypes["LINK"] = "link";
    ButtonTypes["LARGE_LINK"] = "large-link";
    ButtonTypes["ACTION"] = "action";
    ButtonTypes["ICON"] = "icon";
    ButtonTypes["ICON_NEGATIVE"] = "icon-dark";
    ButtonTypes["SMALL_ICON"] = "small-icon";
})(ButtonTypes || (ButtonTypes = {}));
export default ButtonTypes;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQnV0dG9uVHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9AZWlrYS9idXR0b24vc3JjL0J1dHRvblR5cGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLHFDQUFxQztBQUNyQyxJQUFLLFdBYUo7QUFiRCxXQUFLLFdBQVc7SUFDWixnREFBaUMsQ0FBQTtJQUNqQyxnREFBaUMsQ0FBQTtJQUNqQyw2Q0FBOEIsQ0FBQTtJQUM5Qiw2Q0FBOEIsQ0FBQTtJQUM5QixnREFBaUMsQ0FBQTtJQUNqQyxnREFBaUMsQ0FBQTtJQUNqQyw0QkFBYSxDQUFBO0lBQ2Isd0NBQXlCLENBQUE7SUFDekIsZ0NBQWlCLENBQUE7SUFDakIsNEJBQWEsQ0FBQTtJQUNiLDBDQUEyQixDQUFBO0lBQzNCLHdDQUF5QixDQUFBO0FBQzdCLENBQUMsRUFiSSxXQUFXLEtBQVgsV0FBVyxRQWFmO0FBMEJELGVBQWUsV0FBVyxDQUFDIn0=